import { useContext } from 'react';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export function useIsMobileDevice() {
  const { channel } = useContext(ExperienceContext);
  const matches = useBreakpoint('sm');
  const isSmallDevice = matches.exact || matches.lesser;
  return channel === 'mobile' || isSmallDevice;
}
